module.exports = __webpack_public_path__ + "static/media/apple-icon-precomposed.68e6e95d.png";